import { render, staticRenderFns } from "./EntityFormConfigLocale.vue?vue&type=template&id=ab1522f4"
import script from "./EntityFormConfigLocale.vue?vue&type=script&lang=js"
export * from "./EntityFormConfigLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports